// AUTO-GENERATED from /app/backend/data/drug_reference.csv — do not edit by hand.
// Regenerate: python3 /app/backend/generate_pregnancy_ref.py
// t: 'c' = contraindicated in pregnancy (block), 'r' = positive evidence of risk (warn).
// 'all' = list of token-alternative groups; every group must match (combos need every component).
const PREG_REF = [
  {"t":"c","all":[["adapalene"]]},
  {"t":"c","all":[["albendazole"]]},
  {"t":"r","all":[["alprazolam"]]},
  {"t":"r","all":[["amikacin"]]},
  {"t":"c","all":[["amlodipine"],["valsartan"]]},
  {"t":"r","all":[["amphetamine"]]},
  {"t":"c","all":[["anastrozole"]]},
  {"t":"c","all":[["apremilast"]]},
  {"t":"r","all":[["aspirin"]]},
  {"t":"r","all":[["azathioprine"]]},
  {"t":"c","all":[["benazepril"]]},
  {"t":"c","all":[["bendamustine"]]},
  {"t":"r","all":[["betamethasone"]]},
  {"t":"c","all":[["bortezomib"]]},
  {"t":"c","all":[["bosentan"]]},
  {"t":"r","all":[["butalbital"],["acetaminophen","paracetamol"],["caffeine"]]},
  {"t":"c","all":[["candesartan"]]},
  {"t":"c","all":[["capecitabine"]]},
  {"t":"c","all":[["captopril"]]},
  {"t":"r","all":[["carbamazepine"]]},
  {"t":"c","all":[["carboplatin"]]},
  {"t":"r","all":[["celecoxib"]]},
  {"t":"r","all":[["chloramphenicol"]]},
  {"t":"r","all":[["chlordiazepoxide"]]},
  {"t":"c","all":[["cidofovir"]]},
  {"t":"c","all":[["cilostazol"]]},
  {"t":"c","all":[["cisplatin"]]},
  {"t":"r","all":[["clonazepam"]]},
  {"t":"r","all":[["clorazepate"]]},
  {"t":"r","all":[["codeine"]]},
  {"t":"r","all":[["colchicine"]]},
  {"t":"r","all":[["conjugated estrogens"]]},
  {"t":"c","all":[["cyclophosphamide"]]},
  {"t":"r","all":[["cyclosporine","ciclosporin","cyclosporin"]]},
  {"t":"c","all":[["dabrafenib"]]},
  {"t":"c","all":[["dacarbazine"]]},
  {"t":"c","all":[["dactinomycin"]]},
  {"t":"c","all":[["dasatinib"]]},
  {"t":"c","all":[["daunorubicin"]]},
  {"t":"c","all":[["denosumab"]]},
  {"t":"r","all":[["desogestrel"],["ethinyl estradiol"]]},
  {"t":"r","all":[["dexamethasone"]]},
  {"t":"r","all":[["dextroamphetamine"]]},
  {"t":"r","all":[["diazepam"]]},
  {"t":"r","all":[["diclofenac"]]},
  {"t":"c","all":[["dihydroergotamine"]]},
  {"t":"c","all":[["dimethyl fumarate"]]},
  {"t":"r","all":[["dinoprostone"]]},
  {"t":"r","all":[["disopyramide"]]},
  {"t":"r","all":[["divalproex"]]},
  {"t":"c","all":[["docetaxel"]]},
  {"t":"c","all":[["doxorubicin"]]},
  {"t":"r","all":[["doxycycline"]]},
  {"t":"c","all":[["dronabinol"]]},
  {"t":"r","all":[["drospirenone"],["ethinyl estradiol"]]},
  {"t":"c","all":[["dutasteride"]]},
  {"t":"c","all":[["efavirenz"]]},
  {"t":"c","all":[["eletriptan"]]},
  {"t":"c","all":[["enalapril"]]},
  {"t":"c","all":[["enalapril"],["hydrochlorothiazide"]]},
  {"t":"c","all":[["enzalutamide"]]},
  {"t":"c","all":[["epirubicin"]]},
  {"t":"c","all":[["eprosartan"]]},
  {"t":"c","all":[["ergotamine"]]},
  {"t":"r","all":[["estazolam"]]},
  {"t":"r","all":[["estradiol","oestradiol"]]},
  {"t":"r","all":[["etodolac"]]},
  {"t":"r","all":[["etonogestrel"]]},
  {"t":"c","all":[["etoposide"]]},
  {"t":"c","all":[["everolimus"]]},
  {"t":"c","all":[["exemestane"]]},
  {"t":"r","all":[["fentanyl"]]},
  {"t":"c","all":[["finasteride"]]},
  {"t":"c","all":[["fludarabine"]]},
  {"t":"r","all":[["fludrocortisone"]]},
  {"t":"c","all":[["fluorouracil"]]},
  {"t":"r","all":[["flurazepam"]]},
  {"t":"r","all":[["flurbiprofen"]]},
  {"t":"c","all":[["flutamide"]]},
  {"t":"c","all":[["fluvastatin"]]},
  {"t":"r","all":[["fosphenytoin"]]},
  {"t":"c","all":[["frovatriptan"]]},
  {"t":"c","all":[["fulvestrant"]]},
  {"t":"c","all":[["ganciclovir"]]},
  {"t":"c","all":[["gefitinib"]]},
  {"t":"c","all":[["gemcitabine"]]},
  {"t":"c","all":[["gemfibrozil"]]},
  {"t":"r","all":[["gentamicin"]]},
  {"t":"c","all":[["goserelin"]]},
  {"t":"c","all":[["griseofulvin"]]},
  {"t":"r","all":[["hydrocodone"]]},
  {"t":"r","all":[["hydrocortisone"]]},
  {"t":"r","all":[["hydromorphone"]]},
  {"t":"c","all":[["hydroxyurea"]]},
  {"t":"c","all":[["ibandronate"]]},
  {"t":"c","all":[["ibrutinib"]]},
  {"t":"r","all":[["ibuprofen"]]},
  {"t":"c","all":[["idarubicin"]]},
  {"t":"c","all":[["ifosfamide"]]},
  {"t":"c","all":[["imatinib"]]},
  {"t":"r","all":[["indomethacin"]]},
  {"t":"c","all":[["interferon alfa"]]},
  {"t":"c","all":[["irbesartan"]]},
  {"t":"c","all":[["irinotecan"]]},
  {"t":"c","all":[["isavuconazole"]]},
  {"t":"c","all":[["isotretinoin"]]},
  {"t":"c","all":[["itraconazole"]]},
  {"t":"r","all":[["ketoprofen"]]},
  {"t":"c","all":[["ketorolac"]]},
  {"t":"c","all":[["leflunomide"]]},
  {"t":"c","all":[["letrozole"]]},
  {"t":"c","all":[["leuprolide"]]},
  {"t":"c","all":[["lisinopril"]]},
  {"t":"r","all":[["lithium"]]},
  {"t":"c","all":[["lomustine"]]},
  {"t":"r","all":[["lorazepam"]]},
  {"t":"c","all":[["losartan"]]},
  {"t":"c","all":[["lovastatin"]]},
  {"t":"c","all":[["macitentan"]]},
  {"t":"c","all":[["mebendazole"]]},
  {"t":"r","all":[["medroxyprogesterone"]]},
  {"t":"r","all":[["mefenamic acid"]]},
  {"t":"r","all":[["megestrol"]]},
  {"t":"r","all":[["meloxicam"]]},
  {"t":"c","all":[["melphalan"]]},
  {"t":"r","all":[["meperidine","pethidine"]]},
  {"t":"c","all":[["mercaptopurine"]]},
  {"t":"r","all":[["methadone"]]},
  {"t":"r","all":[["methimazole"]]},
  {"t":"c","all":[["methotrexate"]]},
  {"t":"c","all":[["methoxsalen"]]},
  {"t":"r","all":[["methylergonovine"]]},
  {"t":"r","all":[["methylprednisolone"]]},
  {"t":"r","all":[["midazolam"]]},
  {"t":"r","all":[["minocycline"]]},
  {"t":"c","all":[["misoprostol"]]},
  {"t":"c","all":[["mitomycin"]]},
  {"t":"c","all":[["mitotane"]]},
  {"t":"c","all":[["mitoxantrone"]]},
  {"t":"r","all":[["morphine"]]},
  {"t":"c","all":[["mycophenolate mofetil"]]},
  {"t":"r","all":[["nabumetone"]]},
  {"t":"r","all":[["naproxen"]]},
  {"t":"c","all":[["naratriptan"]]},
  {"t":"c","all":[["nilotinib"]]},
  {"t":"r","all":[["nitrofurantoin"]]},
  {"t":"r","all":[["norethindrone"]]},
  {"t":"r","all":[["norgestimate"],["ethinyl estradiol"]]},
  {"t":"c","all":[["obinutuzumab"]]},
  {"t":"c","all":[["olmesartan"]]},
  {"t":"c","all":[["oxaliplatin"]]},
  {"t":"r","all":[["oxaprozin"]]},
  {"t":"r","all":[["oxazepam"]]},
  {"t":"r","all":[["oxycodone"]]},
  {"t":"r","all":[["oxytetracycline"]]},
  {"t":"c","all":[["paclitaxel"]]},
  {"t":"c","all":[["palbociclib"]]},
  {"t":"c","all":[["pamidronate"]]},
  {"t":"c","all":[["pazopanib"]]},
  {"t":"c","all":[["peginterferon alfa"]]},
  {"t":"r","all":[["pentobarbital"]]},
  {"t":"c","all":[["perindopril"]]},
  {"t":"r","all":[["phenobarbital","phenobarbitone"]]},
  {"t":"c","all":[["phentermine"]]},
  {"t":"r","all":[["phenytoin"]]},
  {"t":"r","all":[["piroxicam"]]},
  {"t":"c","all":[["pitavastatin"]]},
  {"t":"c","all":[["pravastatin"]]},
  {"t":"r","all":[["prednisolone"]]},
  {"t":"r","all":[["prednisone"]]},
  {"t":"c","all":[["primaquine"]]},
  {"t":"r","all":[["primidone"]]},
  {"t":"r","all":[["progesterone"]]},
  {"t":"r","all":[["propylthiouracil"]]},
  {"t":"r","all":[["pyrimethamine"]]},
  {"t":"c","all":[["quinapril"]]},
  {"t":"r","all":[["quinine"]]},
  {"t":"c","all":[["raloxifene"]]},
  {"t":"c","all":[["ramipril"]]},
  {"t":"c","all":[["regorafenib"]]},
  {"t":"c","all":[["ribavirin"]]},
  {"t":"c","all":[["risedronate"]]},
  {"t":"c","all":[["rizatriptan"]]},
  {"t":"c","all":[["rosuvastatin"]]},
  {"t":"c","all":[["ruxolitinib"]]},
  {"t":"c","all":[["sacubitril"],["valsartan"]]},
  {"t":"r","all":[["secobarbital"]]},
  {"t":"c","all":[["simvastatin"]]},
  {"t":"c","all":[["sirolimus"]]},
  {"t":"c","all":[["sodium oxybate"]]},
  {"t":"c","all":[["sorafenib"]]},
  {"t":"r","all":[["spironolactone"]]},
  {"t":"r","all":[["streptomycin"]]},
  {"t":"r","all":[["sufentanil"]]},
  {"t":"r","all":[["sulfadiazine"]]},
  {"t":"r","all":[["sulfamethoxazole"]]},
  {"t":"r","all":[["sulindac"]]},
  {"t":"c","all":[["sumatriptan"]]},
  {"t":"c","all":[["sunitinib"]]},
  {"t":"r","all":[["tacrolimus"]]},
  {"t":"r","all":[["tamoxifen"]]},
  {"t":"c","all":[["tazarotene"]]},
  {"t":"c","all":[["telavancin"]]},
  {"t":"c","all":[["telithromycin"]]},
  {"t":"c","all":[["telmisartan"]]},
  {"t":"r","all":[["temazepam"]]},
  {"t":"c","all":[["temozolomide"]]},
  {"t":"c","all":[["temsirolimus"]]},
  {"t":"c","all":[["testosterone"]]},
  {"t":"r","all":[["tetracycline"]]},
  {"t":"c","all":[["thalidomide"]]},
  {"t":"c","all":[["thioguanine"]]},
  {"t":"c","all":[["thiotepa"]]},
  {"t":"r","all":[["tobramycin"]]},
  {"t":"c","all":[["tofacitinib"]]},
  {"t":"r","all":[["tolmetin"]]},
  {"t":"r","all":[["tramadol"]]},
  {"t":"c","all":[["trandolapril"]]},
  {"t":"c","all":[["tretinoin"]]},
  {"t":"r","all":[["triamcinolone"]]},
  {"t":"r","all":[["triazolam"]]},
  {"t":"r","all":[["trimethoprim"]]},
  {"t":"c","all":[["triptorelin"]]},
  {"t":"c","all":[["valganciclovir"]]},
  {"t":"r","all":[["valproic acid"]]},
  {"t":"c","all":[["valsartan"]]},
  {"t":"c","all":[["vandetanib"]]},
  {"t":"c","all":[["varicella vaccine"]]},
  {"t":"c","all":[["vemurafenib"]]},
  {"t":"c","all":[["vinblastine"]]},
  {"t":"c","all":[["vincristine"]]},
  {"t":"c","all":[["vinorelbine"]]},
  {"t":"c","all":[["voriconazole"]]},
  {"t":"r","all":[["warfarin"]]},
  {"t":"c","all":[["zoledronic acid"]]},
  {"t":"c","all":[["zolmitriptan"]]}
];

// Returns 'contraindicated' | 'risk' | null for a lowercased drug-text blob.
export function pregnancyRefLookup(txt) {
  let found = null;
  for (const e of PREG_REF) {
    if (!e.all.every((opts) => opts.some((p) => txt.includes(p)))) continue;
    if (e.t === "c") return "contraindicated";
    found = "risk";
  }
  return found;
}
